

<div class="tabs" [ngClass]="{ 'private-background': activeTab === 'internal' }">
  <div class="tab-buttons">
    <button class="tab-button" *ngIf="showPublicTab" (click)="setActiveTab('public')"
      [ngClass]="{ 'active': activeTab === 'public' }">
      {{"inputs.public_notes" | translate}}

    </button>
    <button class="tab-button" (click)="setActiveTab('internal')" [ngClass]="{ 'active': activeTab === 'internal' }">
      {{"inputs.private_notes" | translate}}
    </button>
  </div>
</div>

<div class="contenedor" [ngClass]="{ 'private-background': activeTab === 'internal' }">
  <!-- <form [formGroup]="form">
    <div class="form-section mt-2">
      <div class="row">
        <div class="mb-3">
          <label for="content" class="form-label">{{
            "inputs.message" | translate
            }}</label>
          <textarea class="form-control textarea200" id="content" rows="5" formControlName="content"></textarea>
        </div>
      </div>
    </div>
  </form> -->
  <form [formGroup]="form">
    <div class="form-section mt-2">
      <div class="row">
        <div class="mb-3">
          <label for="content" class="form-label">
            {{ "inputs.message" | translate }}
          </label>
          <textarea class="form-control textarea200" id="content" rows="5" formControlName="content"
            [attr.disabled]="(activeTab === 'public' && isBrokerSales) ? true : null">
            </textarea>
        </div>
      </div>
    </div>
  </form>
  <div class="div-btn-ring" *ngIf = "activeTab === 'public'">
    <button *ngIf="!require_action_note" class="btn btn-ring filter" type="button" (click)="updateSelectedNotes(true)">
      <i class="icon-alarm-ringing"></i> {{"buttons.required_action" | translate}}
    </button>
    <button *ngIf="require_action_note" class="btn btn-ring filter" type="button" (click)="updateSelectedNotes(false)">
      <i class="icon-alarm-snooze"></i> {{"buttons.not_required_action" | translate}}
    </button>
  </div>
   <div class="div-btn-ring" *ngIf = "activeTab === 'internal'">
    <button *ngIf="!require_private_action_note" class="btn btn-ring filter" type="button" (click)="updatePrivateSelectedNotes(true)">
      <i class="icon-alarm-ringing"></i> {{"buttons.required_action" | translate}}
    </button>
    <button *ngIf="require_private_action_note" class="btn btn-ring filter" type="button" (click)="updatePrivateSelectedNotes(false)">
      <i class="icon-alarm-snooze"></i> {{"buttons.not_required_action" | translate}}
    </button>
  </div>
  <div class="timeline-container">

    <div *ngFor="let itemBig of notes">

      <div *ngFor="let item of itemBig.notes">
        <div class="timeline-item d-flex" [ngClass]="getClass(item.owner)">
          <div class="div-details-notes d-flex flex-column">

            <div class="d-flex align-items-center">
              <div class="details">
                <ul class="no-bullets">
                  <div *ngIf="item.message == 'notes_risk'">
                    <span>{{item.values}}</span>
                  </div>
                  <div *ngIf="item.message == 'notes'">
                    <!-- <span class="pipe-second">{{ "pipe.notes2" | translate}}
                    </span> -->
                    <span [innerHTML]="getFormattedText(item.values)"></span>
                  </div>
                </ul>
                <span class="pipe-second fs12"><i class="icon-user"></i> {{item.created_by}} <i
                    class="icon-calendar-empty ml-7"> </i> {{ item.time }} </span>
                <span class="note-delete-action" *ngIf="item.is_deletable">
                  <button class="btn-delete-note" (click)="deleteNote(item.reference)"
                    [title]="'swal_messages.order_notes.note_delete_confirm_title' | translate">
                    <i class="icon-trash"></i>
                    <span class="countdown-badge">{{ formatCountdown(item.reference) }}</span>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div-date">
        <span class="date">{{ itemBig.date | date : "mediumDate" }}</span>
      </div>
    </div>
  </div>
</div>
